<div #wrapper class="shopping-list-wrapper">
    <app-modal-header [text]="'send_to_friend_btn' | localise" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <div class="modal-body" *ngIf="isSuccess === null" [ngClass]="isIOS() === true ? 'ios' : ''">
        <div class="info-section">
            <label class="font-weight-bold">{{ 'send_to_friend_info_title' | localise }}</label>
            <p class="info-text">{{ 'send_to_friend_info_text' | localise }}</p>
        </div>

        <p>
            <strong>
                {{ getFromDate() }}
            </strong>
            -
            <strong>
                {{ getToDate() }}
            </strong>
        </p>

        <input class="form-control shopping-email"
               [(ngModel)]="email"
               placeholder="{{ 'send_to_friend_email_receipt' | localise }}"
               type="text"/>
    </div>

    <div class="modal-body" *ngIf="isSuccess === true">
        <app-alerts-components
                [type]="'success'"
                [disableClose]="true"
                [icon]="'fa fa-check-circle'"
                [id]="'send_to_friend_success'"
                [title]="'send_to_friend_success_title' | localise"
                [message]="'send_to_friend_success_text' | localise"></app-alerts-components>
    </div>

    <div class="modal-body" *ngIf="isSuccess === false">
        <app-alerts-components
                [type]="'danger'"
                [disableClose]="true"
                [icon]="'fa fa-times-circle'"
                [id]="'send_to_friend_failed'"
                [title]="'send_to_friend_failed_title' | localise"
                [message]="'send_to_friend_failed_text' | localise"></app-alerts-components>
    </div>

    <div class="modal-footer" [ngClass]="isIOS() === true ? 'ios' : ''">
        <button type="button" class="btn btn-secondary"
                (click)="bsModalRef.hide()">{{ 'back' | localise }}</button>
        <button type="button" class="btn btn-success" (click)="save()" *ngIf="isSuccess === null">{{ 'send_to_friend_submit' | localise }}</button>
    </div>
</div>
